export const getLabelStyles = (isError = false) => ({
  marginBottom: '4px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: '2.2rem',
  fontFamily: ({ typography }) => typography.fontFamily,
  color: ({ palette }) => (isError ? `${palette.text.error} !important` : palette.text.secondary),
});
